var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-control-rtmp" },
    [
      _c("ui-checkbox", {
        attrs: { label: "Use a secure connection (TLS/SSL)" },
        model: {
          value: _vm.ssl,
          callback: function ($$v) {
            _vm.ssl = $$v
          },
          expression: "ssl",
        },
      }),
      _vm._v(" "),
      _c("ui-clipboard-input", {
        attrs: {
          value: _vm.rtmpUrl,
          hint: "Link copied to clipboard",
          label: "Stream URL",
        },
      }),
      _vm._v(" "),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-caption" }, [
      _c("p", [
        _vm._v(
          "You can record by adding the stream URL to any third-party device or services supporting RTMP(S). The recording starts as soon as the remote side starts feeding to your stream URL."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "The cloud service supports receiving and recording multiple RTMP(S) sessions at the same time. Each session will result in a recording. The cloud service captures in the quality sent from the remote side, e.g. 720p, 1080p or 4K."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "While your subscription includes recording and storage of videos in 720p quality we welcome that you also record and store videos in higher qualities. We reserve the right to introduce limitations and/or introduce subscription tiers based on video quality in the future."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }